import { ViewModelService } from 'src/app/shared/view-model.service';
import {
  RequesterRecord,
  RequesterViewModelBase,
} from 'src/store/generated/requester-record.generated';
import { RequestViewModel } from './request-view-model';

export class RequesterViewModel extends RequesterViewModelBase {
  constructor(
    requester: RequesterRecord,
    public readonly request: RequestViewModel,
    private readonly _model: ViewModelService,
  ) {
    super(requester);
  }
}
